import { appBridge } from './common';
function uploadImgList(imgList) {
  let uploaedImageList =
    [...imgList].filter((v) => /elfinbook\.com/.test(v)) || [];
  let unUploaedImageList =
    [...imgList].filter((v) => !/elfinbook\.com/.test(v)) || [];
  if (unUploaedImageList.length == 0) {
    return Promise.resolve(uploaedImageList);
  } else {
    return appBridge.uploadBase64Photo(unUploaedImageList).then((list) => {
      return [...uploaedImageList, ...list];
    });
  }
}
export default uploadImgList;
